import React, { useContext } from 'react';
import _ from 'lodash';
import {graphql} from 'gatsby';

import {Layout} from '../components/index';
import Header from '../components/Header';
import {htmlToReact} from '../utils';
import FormField from '../components/FormField';
import Footer from '../components/Footer';
import { InlineWidget } from 'react-calendly';
import { ThemeContext } from '../context/ThemeProvider';
import { VscColorMode } from 'react-icons/vsc';

// this minimal GraphQL query ensures that when 'gatsby develop' is running,
// any changes to content files are reflected in browser
export const query = graphql`
  query($url: String) {
    sitePage(path: {eq: $url}) {
      id
    }
  }
`;

export default function Contact(props) {

  const submitForm = (ev) => {
    ev.preventDefault();
    const form = ev.target;
    const data = new FormData(form);
    const xhr = new XMLHttpRequest();
    xhr.open(form.method, form.action);
    xhr.setRequestHeader("Accept", "application/json");
    xhr.onreadystatechange = () => {
      if (xhr.readyState !== XMLHttpRequest.DONE) return;
      if (xhr.status === 200) {
        form.reset();
        this.setState({ status: "SUCCESS" });
      } else {
        this.setState({ status: "ERROR" });
      }
    };
    xhr.send(data);
  }

  const [mode] = useContext(ThemeContext)

  return (
      <Layout {...props}>
        <Header {...props} site={props.pageContext.site} page={props.pageContext} image={_.get(props, 'pageContext.frontmatter.img_path', null)} />
        <div id="content" className="site-content">
          <main id="main" className="site-main inner">
            <article style={{
              color: mode ? "#fff" : "#000",
              padding: 10
            }} className="post page post-full">
              {_.get(props, 'pageContext.frontmatter.subtitle', null) && (
              <div className="post-subtitle">
                {htmlToReact(_.get(props, 'pageContext.frontmatter.subtitle', null))}
              </div>
              )}
              <div className="post-content">
                {htmlToReact(_.get(props, 'pageContext.html', null))}
                <form name={_.get(props, 'pageContext.frontmatter.form_id', null)} id={_.get(props, 'pageContext.frontmatter.form_id', null)} {...(_.get(props, 'pageContext.frontmatter.form_action', null) ? ({action: _.get(props, 'pageContext.frontmatter.form_action', null)}) : null)} method="POST" data-netlify="true" data-netlify-honeypot="bot-field">
                  <div className="screen-reader-text">
                    <label>Don't fill this out if you're human: <input name="bot-field" /></label>
                  </div>
                  <input type="hidden" name="form-name" value={_.get(props, 'pageContext.frontmatter.form_id', null)} />
                  {_.map(_.get(props, 'pageContext.frontmatter.form_fields', null), (field, field_idx) => (
                    <FormField key={field_idx} {...props} field={field} />
                  ))}
                  <div className="form-submit">
                    <button type="submit" className="button">{_.get(props, 'pageContext.frontmatter.submit_label', null)}</button>
                  </div>
                </form>
              </div>
            </article>
          </main>
          <InlineWidget styles={{
            height: "80vh",
            overflow: "hidden",
            backgroundColor: "#131415"
          }} url="https://calendly.com/digvijaysrathore" />
          <br />
          <Footer {...props} site={props.pageContext.site} page={props.pageContext} image={_.get(props, 'pageContext.frontmatter.img_path', null)} />
        </div>
      </Layout>
  )
}
